const STEP_DIRECTION = {
  NEXT: 'NEXT',
  PREVIOUS: 'PREVIOUS',
};

export { STEP_DIRECTION };
